import { Column, Row } from "@components/Layout";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import type { ParentComponent } from "solid-js";
import { Pill, TracklistDrawerWrapper } from "./styled";

const TracklistDrawer: ParentComponent = (props) => {
	const { t } = useI18n();

	return (
		<TracklistDrawerWrapper padding="16px 10px 10px" gap="10px">
			<Pill />
			<Row justifyContent="center">
				<h4>{t("app.programme.list")}</h4>
			</Row>
			<Column gap="10px" padding="10px 0">
				{props.children}
			</Column>
		</TracklistDrawerWrapper>
	);
};
export default TracklistDrawer;
